/**
 * A simple function that tests if the device is touch capable
 */
const isTouchDevice = function () {
	return 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch);
};

export default isTouchDevice;
